/* unplugin-vue-components disabled */import "core-js/modules/es.function.name.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    service: {
      type: Object
    },
    sparePartList: {
      type: [Object, Array]
    },
    moneyItemList: {
      type: [Object, Array]
    },
    extServiceItems: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    serviceName: function serviceName() {
      var name = this.service.name;
      if (name.length > 7) {
        name = name.substring(0, 7) + '...';
      }
      return name;
    },
    otherServiceCost: function otherServiceCost() {
      return this.extServiceItems.reduce(function (p, c) {
        return p + c.service_price * c.service_num;
      }, 0);
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {}
};